import type { OrderConfirmationPage as OrderConfirmationPageProps } from '@/@types/content';
import withNav from '../hocs/withNav';
import ContentArea from '../cms/ContentArea';

const OrderConfirmationPageComponent: React.FC<OrderConfirmationPageProps> = props => {
  return (
    <>
      <h1 className="heading-1">OrderConfirmation PAGE PLACEHOLDER</h1>
      <ContentArea components={props.mainContentArea} propertyName="mainContentArea" />
    </>
  );
};

const OrderConfirmationPage = withNav(OrderConfirmationPageComponent);
export default OrderConfirmationPage;
